import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

const NavigationBar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeNav = () => setExpanded(false);

  return (
    <Navbar
      expand="lg"
      className={`main-navbar ${isScrolled ? 'scrolled' : ''}`}
      expanded={expanded}
      fixed="top"
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="brand-logo" onClick={closeNav}>
          <div className="logo-container">
            <div className="logo-text">Infrastructure</div>
            <div className="logo-tagline">Building Tomorrow</div>
          </div>
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="main-navbar-nav"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? <FaTimes /> : <FaBars />}
        </Navbar.Toggle>

        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="ms-auto align-items-lg-center">
            <Nav.Link
              as={NavLink}
              to="/"
              className="nav-item-custom"
              onClick={closeNav}
            >
              Home
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/about"
              className="nav-item-custom"
              onClick={closeNav}
            >
              About
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/services"
              className="nav-item-custom"
              onClick={closeNav}
            >
              Services
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/projects"
              className="nav-item-custom"
              onClick={closeNav}
            >
              Projects
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/contact"
              className="nav-item-custom"
              onClick={closeNav}
            >
              Contact
            </Nav.Link>
            <Button
              as={Link}
              to="/contact"
              variant="primary"
              className="btn-quote ms-lg-3 mt-3 mt-lg-0"
              onClick={closeNav}
            >
              Get Quote
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;